import { render, staticRenderFns } from "./sidebarEditProposal.vue?vue&type=template&id=61c6e004&scoped=true&"
import script from "./sidebarEditProposal.vue?vue&type=script&lang=js&"
export * from "./sidebarEditProposal.vue?vue&type=script&lang=js&"
import style0 from "./sidebarEditProposal.vue?vue&type=style&index=0&id=61c6e004&scoped=true&lang=css&"
import style1 from "./sidebarEditProposal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6e004",
  null
  
)

export default component.exports